import { baseToApiShape, baseFromApiShape, baseInitNewForm, baseInitEditForm } from '../formHelpers/base';
import { regionToLocation } from './maasRegions';

/**
 * MaaS/ACM-specific flat → nested API payload.
 * Extends base with: device type, commissioned machines, packages, location, RHEL config.
 */
export function toApiShape(form) {
    const base = baseToApiShape(form);

    // Disable EFA on all node groups (MaaS doesn't support EFA)
    const nodeGroups = (form.nodeGroups || []).map(g => ({ ...g, efa: false }));

    return {
        ...base,
        // MaaS root-level fields
        deviceType: form.deviceType || 'standard',
        commissionedMachineId: form.commissionedMachineId || null,
        commissionedComputeNodes: form.commissionedComputeNodes || [],
        location: form.location || null,
        info: {
            ...base.info,
            prefix: form.prefix || '',
            bursting: { mode: 'off' },
        },
        data: {
            ...base.data,
            packages: form.packages || [],
            rhel_activation_key: form.rhelActivationKey || '',
            rhel_organization_id: form.rhelOrganizationId || '',
            server: {
                ...base.data.server,
                disk_type: form.serverDiskType || '',
                machine: form.serverMachine || '',
            },
            network: {
                ...base.data.network,
                public_ip: form.publicIp || '',
                private_static_ip: form.privateStaticIp || '',
            },
            node: {
                ...base.data.node,
                disk_type: form.nodeDiskType || '',
                group: nodeGroups,
            },
        },
    };
}

export function fromApiShape(cluster) {
    return {
        ...baseFromApiShape(cluster),

        prefix: cluster.info?.prefix || '',
        deviceType: cluster.deviceType || 'standard',
        commissionedMachineId: cluster.commissionedMachineId || null,
        commissionedComputeNodes: cluster.commissionedComputeNodes || [],
        location: cluster.location || null,

        serverDiskType: cluster.data?.server?.disk_type || '',
        serverMachine: cluster.data?.server?.machine || '',
        nodeDiskType: cluster.data?.node?.disk_type || '',

        publicIp: cluster.data?.network?.public_ip || '',
        privateStaticIp: cluster.data?.network?.private_static_ip || '',

        packages: cluster.data?.packages || [],
        rhelActivationKey: cluster.data?.rhel_activation_key || '',
        rhelOrganizationId: cluster.data?.rhel_organization_id || '',
    };
}

export function initNewForm(provider, config) {
    return {
        ...baseInitNewForm(provider, config),
        deviceType: 'standard',
        packages: [],
        burstingMode: 'off',
    };
}

export function initEditForm(cluster, config) {
    const form = {
        ...baseInitEditForm(cluster, config),

        prefix: cluster.info?.prefix || '',
        deviceType: cluster.deviceType || 'standard',
        commissionedMachineId: cluster.commissionedMachineId || null,
        commissionedComputeNodes: cluster.commissionedComputeNodes || [],
        location: cluster.location || null,

        serverDiskType: cluster.data?.server?.disk_type || '',
        serverMachine: cluster.data?.server?.machine || '',
        nodeDiskType: cluster.data?.node?.disk_type || '',
        publicIp: cluster.data?.network?.public_ip || '',
        privateStaticIp: cluster.data?.network?.private_static_ip || '',
        packages: cluster.data?.packages || [],
        rhelActivationKey: cluster.data?.rhel_activation_key || '',
        rhelOrganizationId: cluster.data?.rhel_organization_id || '',
    };
    // Feature: windows-desktop-vms on MaaS - a Windows Desktop has no
    // info['os-type'] (baseInitEditForm's source for osType), so map it back to
    // the form's "Windows Desktop" choice, as azure/formHelpers.js does.
    if (cluster.data?.osFamily === 'windows') {
        form.osType = 'windows-desktop';
        form.enableRdsh = cluster.data?.enable_rdsh || false;
    }
    return form;
}
